

interface ErrorModalProps {
    closeModal: (modalState: boolean) => void;
};

export const PasswordModal = ({closeModal}: ErrorModalProps) => {
  
    return (
        <>
            <div onClick = {() => closeModal(false)} style = {{
                zIndex: '4',
                position: 'absolute',
                top: '0',
                left: '0',
                bottom: '0',
                right: '0',
                background: 'rgba(0, 0, 0, 0.5)',
                cursor: 'pointer',
            }}></div>
            <div style={{
                zIndex: '5',
                background: 'white',
                position: 'fixed',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%,-50%)',
                borderRadius: '5px',
                height: '30%',
                width: '50%',
                paddingLeft: '10px',
            }}>
              
            <p> 
            Current Password was incorrect. Try again.
            </p>
            </div>        
        </>
    );
};